import { render, staticRenderFns } from "./datajob-list.vue?vue&type=template&id=3519230f&scoped=true&"
import script from "./datajob-list.vue?vue&type=script&lang=ts&"
export * from "./datajob-list.vue?vue&type=script&lang=ts&"
import style0 from "./datajob-list.vue?vue&type=style&index=0&id=3519230f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3519230f",
  null
  
)

export default component.exports